"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_GAS_LIMIT_TRANSFER = exports.MIN_GAS_LIMIT_LP_V2_REMOVE_LIQUIDITY = exports.MIN_GAS_LIMIT_LP_V2_ADD_LIQUIDITY = exports.MIN_GAS_LIMIT_BEEFY_VAULT_WITHDRAW = exports.MIN_GAS_LIMIT_BEEFY_VAULT_DEPOSIT = exports.MIN_GAS_LIMIT_0X_SWAP_SHIELD = exports.MIN_GAS_LIMIT_0X_SWAP_TRANSFER = exports.MIN_GAS_LIMIT_0X_SWAP = exports.MIN_GAS_LIMIT_EMPTY_SHIELD = exports.MIN_GAS_LIMIT_EMPTY = exports.MIN_GAS_LIMIT_ANY_RECIPE = exports.MIN_GAS_LIMIT_COMBO_MEAL = void 0;
exports.MIN_GAS_LIMIT_COMBO_MEAL = 2900000n;
exports.MIN_GAS_LIMIT_ANY_RECIPE = 2800000n;
exports.MIN_GAS_LIMIT_EMPTY = 1800000n;
exports.MIN_GAS_LIMIT_EMPTY_SHIELD = 2600000n;
exports.MIN_GAS_LIMIT_0X_SWAP = 2400000n;
exports.MIN_GAS_LIMIT_0X_SWAP_TRANSFER = 2500000n;
exports.MIN_GAS_LIMIT_0X_SWAP_SHIELD = 2700000n;
exports.MIN_GAS_LIMIT_BEEFY_VAULT_DEPOSIT = 3100000n;
exports.MIN_GAS_LIMIT_BEEFY_VAULT_WITHDRAW = 3000000n;
exports.MIN_GAS_LIMIT_LP_V2_ADD_LIQUIDITY = 2700000n;
exports.MIN_GAS_LIMIT_LP_V2_REMOVE_LIQUIDITY = 2300000n;
exports.MIN_GAS_LIMIT_TRANSFER = 1900000n;
